import { useQuery } from "@tanstack/react-query";

import { getSupportWidget } from "@/services";

/** The site's live chat settings; one query shared by the loader and every support button. */
export const useSupportWidgetConfig = () =>
  useQuery({
    queryKey: ["support-widget"],
    queryFn: getSupportWidget,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

/** True once the API says a chat is set up; false while it loads or when it failed. */
export const useSupportChatEnabled = () => {
  const { data } = useSupportWidgetConfig();
  return !!data && data.provider !== "none" && !!data.providerId;
};
